module.exports = __webpack_public_path__ + "media/assets/community_index/icon-info-684e471fd67115a74841abf413fe1645026d4a13475dba90c2469598ebe16cf9.svg";